// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./FormToggle";
export type { FormToggleProps } from "./FormToggle";
